import React from 'react';
import Panel from '../panels/Panel';
import StaticContent from '@/components/common/StaticContentPage';

const Disclaimer = ({showButton=true}) => {
    return <StaticContent 
        header={"Welcome to our 'proof of concept' for Live Trivia!"}
        showButton={false}
    >
        <p className={'font-gReg text-base'}>{"We're building a new game mode which will allow you to dive into an endless stream of trivia questions, and compete live with thousands of other real players in the Trivial Putsuit community! In this early demo, we'll be learning from you what makes Live Trivia fun!"}</p>
        <div>
            <h3 className={'font-gSemi mb-2 text-base'}>{"Here's how to play:"}</h3>
            <ul className={'list-disc mx-6 flex flex-col gap-2 font-gReg text-base'}>
                <li>{"There's a new trivia questions every 30 seconds."}</li>
                <li>{"Correct answers earn a wedge. Earn bonus wedges for answering correctly quickly! Your cumulative score and current streak are displayed in the top right corner of the screen."}</li>
                <li>{"Compete for the highest score on the leader boards across different time periods!"}</li>
                <li>{"You can join or leave Trivial Pursuit live at any time. Your score and current streak will always be saved."}</li>
                <li>{"Don't forget to leave feedback on questions!"}</li>
            </ul>
        </div>
        <div className={`${!showButton && 'hidden '} grid grid-cols-3 place-items-center`}> 
            <button 
                className={"flex col-start-2 bg-primary text-white py-2 rounded-md font-gBold uppercase px-4 w-full justify-center mt-4"} 
                onClick={() => window.location.reload()}
            >
                Play 
            </button>
        </div>
    </StaticContent>
}

export default Disclaimer;